import { render, staticRenderFns } from "./modalSubirImagen.vue?vue&type=template&id=42b97412&"
import script from "./modalSubirImagen.vue?vue&type=script&lang=js&"
export * from "./modalSubirImagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports